import React from 'react';
import { Grid } from '@material-ui/core';
import greyArrow from 'core/assets/svg/icGreyArrowRight.svg';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import ValueField from 'core/components/value-field';
import useStyles from './compare-offer.styles';

export const CompareHeaderMeta = ({ offer }) => {
  const classes = useStyles();
  const coApplicant = offer.quote?.drivers?.find((d) => d.isCoApplicant);

  return (
    <>
      {offer.webUserId && (
        <Grid container item direction="row" alignItems="baseline" className={classes.metaRow}>
          <Label className={classes.subtitle} type="infoLabel">
            Pre-bind ID
          </Label>
          <Label type="infoValue">
            <Grid container alignItems="center">
              {offer.webUserId}
            </Grid>
          </Label>
        </Grid>
      )}
      <Grid container item direction="row" alignItems="baseline" className={classes.metaRow}>
        <Label className={classes.subtitle} type="infoLabel">
          Applicant
        </Label>
        <Label type="infoValue">
          {offer.quote?.fname} {offer.quote?.lname}
        </Label>
      </Grid>
      <Grid container item direction="row" alignItems="baseline" className={classes.metaRow}>
        <Label className={classes.subtitle} type="infoLabel">
          Co-applicant
        </Label>
        <Label type="infoValue">{coApplicant ? `${coApplicant.firstName} ${coApplicant.lastName}` : 'N/A'}</Label>
      </Grid>
    </>
  );
};

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\./gi;

//removes UUID from key so it is not displayed in diff
const removeUUIDFromKey = (path) => path.replace(UUID_PATTERN, '');

//used for the highlight in the diff
const getInlineDiff = (prev = '', curr = '') => ({
  prev: [{ text: prev, highlight: true }],
  curr: [{ text: curr, highlight: true }]
});

export const OfferIdPairCard = ({
  previousLabel = 'Previous offer ID',
  previousDate,
  previousOfferId,
  newerLabel = 'Newer offer ID',
  newerDate,
  newerOfferId,
  action,
  footer
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.offerIdCard}>
      <Grid container direction="row" alignItems="center" justifyContent="space-between">
        <Grid item container direction="row" alignItems="center" className={classes.offerIdPair}>
          <Grid item className={classes.offerIdBlock}>
            {previousDate && (
              <Label type="infoLabel" className={classes.offerDateLabel}>
                {previousDate}
              </Label>
            )}
            <ValueField label={previousLabel} value={previousOfferId} copyable className={classes.offerIdKeyLabel} />
          </Grid>
          <Grid item className={classes.offerIdArrow}>
            <img src={greyArrow} alt="to" />
          </Grid>
          <Grid item className={classes.offerIdBlock}>
            {newerDate && (
              <Label type="infoLabel" className={classes.offerDateLabel}>
                {newerDate}
              </Label>
            )}
            <ValueField label={newerLabel} value={newerOfferId} copyable className={classes.offerIdKeyLabel} />
          </Grid>
        </Grid>
        {action}
      </Grid>
      {footer}
    </Card>
  );
};

export const OfferDiffTable = ({
  previousHeader = 'Previous offer values',
  newerHeader = 'Newer offer values',
  oldOfferId,
  newOfferId,
  changes
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tableWrapper}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.th}>
              {previousHeader}
              <br />({oldOfferId})
            </th>
            <th className={classes.th}>
              {newerHeader}
              <br />({newOfferId})
            </th>
          </tr>
        </thead>
        <tbody>
          {changes.map(({ path, previousValue, currentValue }) => {
            const diff = getInlineDiff(previousValue, currentValue);
            return (
              <tr key={path}>
                <td className={`${classes.td} ${classes.tdPrevious}`}>
                  <span className={classes.fieldPath}>{removeUUIDFromKey(path)}:</span>{' '}
                  {diff.prev.map(({ text, highlight }, i) =>
                    highlight ? (
                      <mark key={i} className={classes.highlightPrevious}>
                        {text}
                      </mark>
                    ) : (
                      text
                    )
                  )}
                  ,
                </td>
                <td className={`${classes.td} ${classes.tdCurrent}`}>
                  <span className={classes.fieldPath}>{removeUUIDFromKey(path)}:</span>{' '}
                  {diff.curr.map(({ text, highlight }, i) =>
                    highlight ? (
                      <mark key={i} className={classes.highlightCurrent}>
                        {text}
                      </mark>
                    ) : (
                      text
                    )
                  )}
                  ,
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
